import { BaseAccomodation } from "./base-accomodation.model";

export class SaveAccomodation {
        constructor(
        public detail? : string,
        public saveAccomodationDto?: BaseAccomodation
    ) {}
}